export const IS_PCH_LOCAL_STORAGE_KEY = "@SnxPayment:isPch";
